<div class="household-contact-grid" [formGroup]="formGroup">
  <div class="household-contact-header">
    <h5 class="household-section-title">Parent Contact Information</h5>
  </div>
  <div class="household-contact-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="address1" class="field-label">Street Address</label>
      <mat-form-field class="household-fields">
        <input id="address1"
               matInput
               type="text"
               placeholder="Street Address"
               class="user-record-field-input"
               formControlName="address1" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('address1')" />
    </div>
  </div>
  <div class="household-contact-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="address2" class="field-label">Street Address 2 (Optional)</label>
      <mat-form-field class="household-fields">
        <input id="address2"
               matInput
               type="text"
               placeholder="Apt, Suite, etc."
               class="user-record-field-input"
               formControlName="address2" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('address2')" />
    </div>
  </div>
  <div class="household-contact-field half-width">
    <div class="user-record-field-wrapper">
      <label for="city" class="field-label">City</label>
      <mat-form-field class="household-fields">
        <input id="city"
               matInput
               type="text"
               placeholder="City"
               class="user-record-field-input"
               formControlName="city" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('city')" />
    </div>
  </div>
  <div class="household-contact-field half-width">
    <div class="user-record-field-wrapper">
      <label for="state" class="field-label">State</label>
      <mat-form-field class="household-fields">
        <input id="state"
               matInput
               type="text"
               placeholder="State"
               class="user-record-field-input"
               formControlName="state"
               [matAutocomplete]="stateAuto" />
        <mat-autocomplete #stateAuto="matAutocomplete" [displayWith]="displayStateName">
          @for (state of filteredStates | async; track state) {
          <mat-option [value]="state">{{ state.name }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('state')" />
    </div>
  </div>
  <div class="household-contact-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="zip" class="field-label">Zip code</label>
      <mat-form-field class="household-fields">
        <input id="zip"
               matInput
               type="text"
               maxlength="5"
               placeholder="12345"
               class="user-record-field-input"
               formControlName="zip" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('zip')" />
    </div>
  </div>
  @if (isNorthCarolina()) {
  <div class="household-contact-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="county" class="field-label">County</label>
      <mat-form-field class="household-fields">
        <input id="county"
               matInput
               type="text"
               placeholder="County"
               class="user-record-field-input"
               formControlName="county"
               [matAutocomplete]="countyAuto" />
        <mat-autocomplete #countyAuto="matAutocomplete">
          @for (county of filteredCounties | async; track county) {
          <mat-option [value]="county.name">{{ county.name }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('county')" />
    </div>
  </div>
  }
  <div class="household-contact-field half-width">
    <div class="user-record-field-wrapper">
      <label for="email" class="field-label">Email Address</label>
      <input id="email"
             matInput
             type="email"
             placeholder="Email Address"
             class="user-record-field-input"
             formControlName="email" />
    </div>
  </div>

  <div class="household-contact-field half-width">
    <div class="user-record-field-wrapper">
      <label for="phone" class="field-label">Phone No.</label>
      <mat-form-field class="household-fields">
        <input id="phone"
               matInput
               type="text"
               [mask]="'(000) 000-0000'"
               formControlName="phone"
               placeholder="(123) 456-7890"
               class="user-record-field-input"
               [dropSpecialCharacters]="true" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('phone')" />
    </div>
  </div>
</div>
